"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

var defaultBody = function defaultBody(_ref) {
  var children = _ref.children,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon;
  return {
    __children: (0, _.jsx)(_react["default"].Fragment, null, leftIcon, children, rightIcon)
  };
};

var _default = function _default(props) {
  var leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      children = props.children,
      _sx = props.sx,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["leftIcon", "rightIcon", "children", "sx"]);
  return (0, _.jsx)(_ButtonBase["default"], (0, _extends2["default"])({}, restProps, {
    sx: function sx(state) {
      _sx = typeof _sx === "function" ? _sx(state) : _sx;

      var _splitSx = (0, _.splitSx)(_sx),
          _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
          css = _splitSx2[0],
          customSx = _splitSx2[1];

      var $leftIcon = customSx.$leftIcon,
          $rightIcon = customSx.$rightIcon,
          $body = customSx.$body,
          $gap = customSx.$gap,
          $iconSize = customSx.$iconSize,
          restSx = (0, _objectWithoutProperties2["default"])(customSx, ["$leftIcon", "$rightIcon", "$body", "$gap", "$iconSize"]);
      var gap = $gap || 0;
      var iconSize = $iconSize || "auto"; // TODO: wrapper should not be there, styles should be applied directly to icon. We should have `size` parameter for Icons and we can have fixed amount of icon sizes!

      var leftIconWrapper = leftIcon && (0, _.jsx)(_Box["default"], {
        sx: (0, _objectSpread2["default"])({
          mr: gap,
          flex: "0 0 auto",
          width: iconSize,
          height: iconSize
        }, $leftIcon)
      }, _react["default"].cloneElement(leftIcon, {
        style: {
          width: "100%",
          height: "100%"
        }
      }));
      var rightIconWrapper = rightIcon && (0, _.jsx)(_Box["default"], {
        sx: (0, _objectSpread2["default"])({
          ml: gap,
          flex: "0 0 auto",
          width: iconSize,
          height: iconSize
        }, $rightIcon)
      }, _react["default"].cloneElement(rightIcon, {
        style: {
          width: "100%",
          height: "100%"
        }
      }));
      var newState = (0, _objectSpread2["default"])({}, state, {
        leftIcon: leftIconWrapper,
        rightIcon: rightIconWrapper,
        children: children
      });
      var bodySpec = (0, _.getElementSpec)($body, defaultBody, newState);
      return (0, _objectSpread2["default"])({
        $css: css,
        $body: bodySpec
      }, restSx);
    }
  }));
};

exports["default"] = _default;